"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  align-items: center;\n  margin: -6px 0 -6px auto;\n\n  > * {\n    margin-left: 12px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  min-height: 80px;\n  margin: -25px -24px 0;\n  padding: 25px 24px;\n  align-items: center;\n  width: calc(100% + 48px);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PanelHeader = _styledComponents.default.div.withConfig({
  displayName: "PanelHeader",
  componentId: "sc-10eirpi-0"
})(_templateObject());

PanelHeader.displayName = "CPanel.Header";
PanelHeader.Actions = _styledComponents.default.div.withConfig({
  displayName: "PanelHeader__Actions",
  componentId: "sc-10eirpi-1"
})(_templateObject2());
PanelHeader.Actions.displayName = "CPanel.Header.Actions";
var _default = PanelHeader;
exports.default = _default;